module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/067-kenya-9fc73328c7270e3553c890698931af48.svg";